<template>
  <div class="login">
    <div class="login-card">
      <img
        :src="logo_url"
        alt="company-logo"
        class="logo"
      >
      <h1>{{ label_login }}</h1>
      <p>Login into your account</p>

      <b-form
        @reset="onReset"
        @keyup.enter="onSubmit"
      >
        <b-form-group>
          <b-form-input
            v-model="$v.form.username.$model"
            :class="{'error-input' : $v.form.username.$error}"
            :error-message="null"
            placeholder="Username"
            type="text"/>
        </b-form-group>
        <b-form-group id="loginPasswordInputLdap">
          <b-form-input
            :type="password_id"
            :error-message="null"
            :class="{'error-input' : $v.form.password.$error}"
            v-model="$v.form.password.$model"
            placeholder="Password"/>
          <label>
            <i
              :class="{'fa fa-eye': !show_pass, 'fa fa-eye-slash': show_pass}"
              role="img"
              @click="show_pass=!show_pass"/>
          </label>
        </b-form-group>

        <b-button
          :class="{'disabled': $v.form.$invalid}"
          :disabled="$v.form.$invalid"
          class="btn-login"
          @click="onSubmit"
        >
          Login
        </b-button>
      </b-form>

      <img
        src="@/assets/logo/logo_oos.png"
        alt="oos-logo"
        class="logo-oos"
      >
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      show_pass: false,
    };
  },
  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
        minLength: minLength(5),
      },
    },
  },
  computed: {
    password_id() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },
    label_login() {
      if (process.env.SIGNIN_WITH_LDAP_NAME) {
        return process.env.SIGNIN_WITH_LDAP_NAME;
      }
      return 'Authentication';
    },
    logo_url() {
      if (process.env.SIGNIN_WITH_LDAP_LOGO_URL) {
        return process.env.SIGNIN_WITH_LDAP_LOGO_URL;
      }
      // eslint-disable-next-line
      return require('@/assets/img/studio-logo.png');
    },
  },
  methods: {
    ...mapActions('jStoreLogin', ['LoginLdapAccount']),

    onSubmit() {
      this.$v.form.$touch();
      if (!this.$v.form.$error && !this.$v.form.$invalid) {
        this.LoginLdapAccount(this.form);
      }
    },

    onReset() {
      this.form.username = '';
      this.form.password = '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .login {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../../assets/img/background-login.svg');
    background-size: cover;
    background-position: center;

    &-card {
      width: 464px;
      max-height: 717px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px;
      border-radius: 10px;
      background-color: rgba(255, 255, 255, 0.38);
      box-shadow: 0px 0px 19px rgba(190, 190, 190, 0.25);
      backdrop-filter: blur(100px);

      .logo {
        margin-top: 70px;
        width: auto;
        height: 138px;
        margin-bottom: 20px;
      }
      h1 {
        font-family: 'Poppins-Medium';
        font-size: 36px;
        color: #000;
        margin-bottom: 4px;
      }
      p {
        font-family: 'Poppins-Regular';
        font-size: 18px;
        color: #000;
        margin-bottom: 40px;
      }
      form {
        width: 100%;
      }
      input {
        font-family: 'Poppins-Regular';
        font-size: 16px;
        color:#5A5A5A;
        padding: 28px 24px;
        border-radius: 10px;
        margin-bottom: 10px;
      }
      .btn-login {
        width: 100%;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $primary-sample;
        font-family: 'Poppins-Medium';
        font-size: 18px;
        color: white;
        border-radius: 10px;
        margin-top: 16px;

        &:hover {
          background: darken($blue-sample, 20%);
        }
        &.disabled {
          cursor: not-allowed;
        }
      }
      .logo-oos {
        width: auto;
        height: 20px;
        margin-top: 60px;
      }
    }

    #loginPasswordInputLdap, #loginPasswordInput > div {
      position: relative;
    }

    #loginPasswordInputLdap > div label{
      position: absolute;
      top: 15px;
      right: 11px;
      font-size: 26px;
    }
  }

  @media screen and (max-width: 550px) {
    .login {
      &-card {
        width: 400px;
        input {
          font-size: 14px;
        }
      }
    }
  }

  @media screen and (max-height: 685px) {
    .login {
      &-card {
        max-height: 600px;

        .logo {
          margin-top: 20px;
          height: 115px;
        }
        h1 {
          font-size: 32px;
        }
        p {
          font-size: 16px;
        }
        input {
          padding: 24px 20px;
        }
        .btn-login {
          height: 50px;
          font-size: 16px;
        }
        .logo-oos {
          margin-top: 40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/jLoginLdap.vue